import { makeStyles } from '@material-ui/core/styles';
import { claymorphismColors } from '../constants/colors';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // Fixed height to enable scrolling within parent's overflow:hidden
    height: '100vh',
    background: 'linear-gradient(135deg, #FFF8E1 0%, #FFECB3 50%, #FFF3E0 100%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowX: 'hidden',
    overflowY: 'auto',
    // Smooth scrolling for iOS
    WebkitOverflowScrolling: 'touch',
    // Support dynamic viewport height for mobile browsers
    '@supports (height: 100dvh)': {
      height: '100dvh',
    },
  },

  // Content wrapper
  contentWrapper: {
    flexShrink: 0, // Prevent shrinking - allow natural height
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '32px 24px',
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px',
    },
  },

  // Thank you card (Claymorphism style)
  thankCard: {
    maxWidth: '600px',
    width: '100%',
    borderRadius: '24px',
    border: '3px solid rgba(255, 255, 255, 0.6)',
    padding: '48px 32px',
    background: `linear-gradient(145deg, ${claymorphismColors.softCyan}, #B2EBF2)`,
    boxShadow: `
      8px 8px 16px rgba(0, 0, 0, 0.08),
      -5px -5px 12px rgba(255, 255, 255, 0.9),
      inset 2px 2px 4px rgba(255, 255, 255, 0.6),
      inset -1px -1px 2px rgba(0, 0, 0, 0.03)
    `,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: '32px 20px',
      borderRadius: '20px',
    },
  },

  // Success icon
  successIcon: {
    fontSize: '80px',
    color: '#4CAF50',
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '60px',
      marginBottom: '16px',
    },
  },

  // Title
  thankTitle: {
    fontSize: '2rem',
    fontWeight: 700,
    color: claymorphismColors.text,
    marginBottom: '8px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  thankSubtitle: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: claymorphismColors.textLight,
    marginBottom: '32px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      marginBottom: '24px',
    },
  },

  // Button (Claymorphism style)
  backButton: {
    padding: '14px 32px',
    borderRadius: '16px',
    border: '3px solid rgba(255, 255, 255, 0.5)',
    background: `linear-gradient(145deg, ${claymorphismColors.softPeach}, #FFB4A2)`,
    boxShadow: `
      5px 5px 10px rgba(253, 188, 180, 0.4),
      -3px -3px 8px rgba(255, 255, 255, 0.5),
      inset 2px 2px 4px rgba(255, 255, 255, 0.4)
    `,
    cursor: 'pointer',
    transition: 'all 0.2s ease-out',
    '&:hover': {
      background: `linear-gradient(145deg, #FFB4A2, ${claymorphismColors.softPeach})`,
      transform: 'translateY(-2px)',
      boxShadow: `
        7px 7px 14px rgba(253, 188, 180, 0.5),
        -4px -4px 10px rgba(255, 255, 255, 0.6),
        inset 2px 2px 4px rgba(255, 255, 255, 0.4)
      `,
    },
    '&:active': {
      transform: 'translateY(0)',
      boxShadow: `
        2px 2px 5px rgba(253, 188, 180, 0.3),
        -1px -1px 4px rgba(255, 255, 255, 0.3),
        inset 3px 3px 6px rgba(0, 0, 0, 0.08)
      `,
    },
  },
  backButtonText: {
    fontSize: '1rem',
    fontWeight: 600,
    color: claymorphismColors.text,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9rem',
    },
  },
}));

export default useStyles;
